import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classnames from 'classnames';
import { forwardRef } from 'react';
import { flags } from './flags';
import { IconLoading } from './icons';
import { useTooltip } from './tooltip';
export const Button = forwardRef(function Button({ children, className, disabled, label, loading = false, size = 'md', type = 'button', tooltipOptions, variant = 'default', onDisabledClick, 'aria-disabled': ariaDisabled, ...rest }, ref) {
    const classes = classnames(className, {
        'pds-button': variant !== 'link',
        [`pds-button-${variant}`]: variant !== 'default',
        [`pds-button-${size}`]: size !== 'md',
    });
    const DISABLED_EVENTS = [
        'onClick',
        'onDoubleClick',
        'onKeyDown',
        'onKeyUp',
        'onMouseDown',
        'onMouseUp',
    ];
    if (flags.ariaDisabledButton && disabled) {
        const remainingProps = rest;
        for (const name of DISABLED_EVENTS) {
            remainingProps[name] = remainingProps[`${name}Capture`] = function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (name === 'onClick' && onDisabledClick)
                    onDisabledClick();
            };
        }
    }
    if (flags.ariaDisabledButton) {
        if (disabled || loading) {
            ariaDisabled = 'true';
        }
    }
    const tooltip = useTooltip(tooltipOptions);
    return (_jsxs(_Fragment, { children: [tooltip?.element, _jsxs("button", { ref: ref, ...rest, ...tooltip?.targetProps, type: type, className: classes, disabled: !flags.ariaDisabledButton && disabled, "aria-disabled": ariaDisabled, children: [loading && _jsx(IconLoading, { "aria-hidden": "true" }), children || label, loading && `…`] })] }));
});
